module.exports = __webpack_public_path__ + "img/3.6de13cd5.jpg";